import * as Yup from "yup";

export const influencerSchema = Yup.object().shape({
  influencers: Yup.array()
    .of(
      Yup.object().shape({
        firstName: Yup.string()
          .typeError("First Name is required.")
          .required("First Name is required."),
        lastName: Yup.string()
          .typeError("Last Name is required.")
          .required("Last Name is required."),
        age: Yup.number()
          .typeError("Age must be number.")
          .required("Age is required.")
          .min(12, "Age must be greater than 12.")
          .max(100, "Age must be less than 100."),
        category: Yup.array()
          .typeError("Category should be array.")
          .of(Yup.string().required("Each category should be string."))
          .min(1, "Atleast one category should be selected.")
          .required("Category is required."),
        phoneNo: Yup.string()
          .typeError("Phone Number is required.")
          .required("Phone Number is required.")
          .matches(/^[0-9]{10}$/, "Mobile number must be 10 digits."), // Regex for 10 digits,
        email: Yup.string()
          .email("Email Id should be valid.")
          .typeError("Email ID is required.")
          .required("Email ID is required."),
        address: Yup.string()
          .typeError("Address is required.")
          .required("Address is required."),
        socialLinks: Yup.object().shape({
          instagram: Yup.string()
            .typeError("Instagram Profile should be a string.")
            .required("Instagram Profile is required.")
            .matches(
              /^@[A-Za-z0-9._]{1,29}$/,
              "Instagram Profile should starts with @ and only contains . and _ as special characters."
            ),
          instagramVerified: Yup.boolean()
            .typeError("Instagram Verified Profile should be a boolean.")
            .test(
              "is-verified",
              "Instagram profile must be verified, Please click on connect.",
              function (value) {
                const { instagram } = this.parent; // Get the Instagram value
                if (instagram && instagram.trim()?.length > 1) {
                  return value === true; // Must be true if Instagram exists
                }
                return true; // If no Instagram, allow any value
              }
            ),
          youtube: Yup.string()
            .typeError("Youtube Profile should be a string.")
            .matches(
              /^@[A-Za-z0-9._]{1,29}$/,
              "Youtube Profile should starts with @ and only contains . and _ as special characters."
            ),
          youtubeVerified: Yup.boolean()
            .typeError("Youtube Verified Profile should be a boolean.")
            .test(
              "is-verified",
              "Youtube profile must be verified, Please click on connect.",
              function (value) {
                const { youtube } = this.parent; // Get the youtube value
                if (youtube && youtube.trim()?.length > 1) {
                  return value === true; // Must be true if youtube exists
                }
                return true; // If no youtube, allow any value
              }
            ),
          facebook: Yup.string().typeError(
            "Facebook Profile should be a string."
          ),
          facebookVerified: Yup.boolean().typeError(
            "Facebook Verified Profile should be a boolean."
          ),
          linkedin: Yup.string().typeError(
            "LinkedIn Profile should be a string."
          ),
          linkedinVerified: Yup.boolean().typeError(
            "LinkedIn Verified Profile should be a boolean."
          ),
          snapchat: Yup.string().typeError(
            "Snapchat Profile should be a string."
          ),
          snapchatVerified: Yup.boolean().typeError(
            "Snapchat Verified Profile should be a boolean."
          ),
          twitch: Yup.string().typeError("Twitch Profile should be a string."),
          twitchVerified: Yup.boolean().typeError(
            "Twitch Verified Profile should be a boolean."
          ),
          twitter: Yup.string().typeError(
            "Twitter Profile should be a string."
          ),
          twitterVerified: Yup.boolean().typeError(
            "Twitter Verified Profile should be a boolean."
          ),
          reddit: Yup.string().typeError("reddit Profile should be a string."),
          redditVerified: Yup.boolean().typeError(
            "Reddit Verified Profile should be a boolean."
          ),
          quora: Yup.string().typeError("Quora Profile should be a string."),
          quoraVerified: Yup.boolean().typeError(
            "Quora Verified Profile should be a boolean."
          ),
        }),
      })
    )
    .min(1, "At least one influencer is required")
    .required("Influencers field is required")
    .test(
      "unique-email",
      "Emails must be unique across influencers.",
      function (influencers) {
        if (!influencers) return true;
        const emails = influencers.map((i) => i.email?.toLowerCase());
        const uniqueEmails = new Set(emails);
        return uniqueEmails.size === emails.length;
      }
    )
    .test(
      "unique-social-handles",
      "Each social media handle must be unique across influencers.",
      function (influencers) {
        if (!influencers) return true;

        const checkDuplicates = (fieldPath) => {
          const values = influencers
            .map((i) => {
              const parts = fieldPath.split(".");
              let value = i;
              for (const part of parts) {
                value = value?.[part];
              }
              return value?.toLowerCase?.() || null;
            })
            .filter(Boolean);

          return new Set(values).size === values.length;
        };

        return (
          checkDuplicates("socialLinks.instagram") &&
          checkDuplicates("socialLinks.youtube") &&
          checkDuplicates("socialLinks.facebook") &&
          checkDuplicates("socialLinks.linkedin") &&
          checkDuplicates("socialLinks.snapchat") &&
          checkDuplicates("socialLinks.twitch") &&
          checkDuplicates("socialLinks.twitter") &&
          checkDuplicates("socialLinks.reddit") &&
          checkDuplicates("socialLinks.quora")
        );
      }
    ),
});
